import request from '@/utils/request'

// 子账户列表接口
export const getUpstreamAccount = (params: any) =>
  request({
    url: 'manage/upstream-account',
    method: 'get',
    params
  })

// 解锁
export const getUnlockAccount = (data: any) =>
  request({
    url: 'manage/upstream-account/' + data.id,
    method: 'patch',
    data: data.body
  })

// 锁定
export const setLockAccount = (data: any) =>
  request({
    url: 'manage/upstream-account/' + data.id,
    method: 'patch',
    data: data.body
  })

// 审核
export const setReview = (data: any) =>
  request({
    url: 'manage/upstream-account/' + data.id,
    method: 'patch',
    data
  })
